import { render, staticRenderFns } from "./checkout-cart-promo.vue?vue&type=template&id=cbef94ac&scoped=true&"
import script from "./checkout-cart-promo.vue?vue&type=script&lang=js&"
export * from "./checkout-cart-promo.vue?vue&type=script&lang=js&"
import style0 from "./checkout-cart-promo.vue?vue&type=style&index=0&id=cbef94ac&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbef94ac",
  null
  
)

export default component.exports